var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4141 4.32007H3.53906C3.34015 4.32007 3.14938 4.24105 3.00873 4.1004C2.86808 3.95975 2.78906 3.76898 2.78906 3.57007C2.78906 3.37116 2.86808 3.18039 3.00873 3.03974C3.14938 2.89909 3.34015 2.82007 3.53906 2.82007H20.4141C20.613 2.82007 20.8037 2.89909 20.9444 3.03974C21.085 3.18039 21.1641 3.37116 21.1641 3.57007C21.1641 3.76898 21.085 3.95975 20.9444 4.1004C20.8037 4.24105 20.613 4.32007 20.4141 4.32007Z",
    fill: "#EFEDE0",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4395 7.69507H3.56445C3.36554 7.69507 3.17478 7.61605 3.03412 7.4754C2.89347 7.33475 2.81445 7.14398 2.81445 6.94507C2.81445 6.74616 2.89347 6.55539 3.03412 6.41474C3.17478 6.27409 3.36554 6.19507 3.56445 6.19507H20.4395C20.6384 6.19507 20.8291 6.27409 20.9698 6.41474C21.1104 6.55539 21.1895 6.74616 21.1895 6.94507C21.1895 7.14398 21.1104 7.33475 20.9698 7.4754C20.8291 7.61605 20.6384 7.69507 20.4395 7.69507Z",
    fill: "#EFEDE0",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0391 4.32007H3.91406V6.19507H20.0391V4.32007Z",
    fill: "#F6F6EC",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91406 7.69507V21.1951H8.41406V13.9576C8.41406 13.4897 8.50621 13.0265 8.68524 12.5943C8.86427 12.162 9.12669 11.7693 9.45749 11.4385C9.7883 11.1077 10.181 10.8453 10.6133 10.6662C11.0455 10.4872 11.5087 10.3951 11.9766 10.3951C12.4444 10.3951 12.9076 10.4872 13.3399 10.6662C13.7721 10.8453 14.1648 11.1077 14.4956 11.4385C14.8264 11.7693 15.0889 12.162 15.2679 12.5943C15.4469 13.0265 15.5391 13.4897 15.5391 13.9576V21.1951H20.0391V7.69507H3.91406Z",
    fill: "#F6F6EC",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6895 10.3201H18.5645",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.43945 10.3201H7.31445",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91406 13.7097H8.41406",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5645 13.6951H19.6895",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5391 18.6143H20.0391",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93945 18.5701H8.43945",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7891 13.8616V20.9866",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16406 13.8616V20.9866",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonuments);
export default __webpack_public_path__ + "static/media/Monuments.3e74f1c34a97600e4329d147ac050d2a.svg";
export { ForwardRef as ReactComponent };